/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FilterOptions {
    NEW = 'new',
    CLIENT = 'client',
    WITHOUT_ACCOUNT = 'without-account',
    WITH_ACCOUNT = 'with-account',
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}
